import React from 'react';
import { observer } from 'mobx-react';
import { SeekerLeftComponent } from './seekerLeftComponent';
import { SeekerRightComponent } from './SeekerRightComponent';

const Seeker = observer(props => {
  const [isGoogleTab, setGoogleTab] = React.useState(false);

  const googleSheetBtnClick = () => {
    setGoogleTab(true);
  };

  const seekerAction = () => {
    setGoogleTab(false);
  };

  return (
    <div className="seekerPage">
      <div className="leftSection">
        <SeekerLeftComponent
          seekerAction={seekerAction}
          googleSheetBtnAction={googleSheetBtnClick}
          isGoogleTabSelected={isGoogleTab}
        />
      </div>
      <div className="rightSection">
        <SeekerRightComponent isGoogleTabSelected={isGoogleTab} />
      </div>
    </div>
  );
});

export { Seeker };
export default Seeker;
